import axios from 'axios';
import { BASE_URL } from './api';


export async function getCompanyWebsiteSpiderJobs(token, queryParams){
    return axios({
        method: 'get',
        url: `${BASE_URL}/company_website_spider_crawl_job${queryParams}`,
        headers : {
            'Authorization': `Token ${token}`
        }
    }).then((response) => {
        return response
    }).catch(error => error)
}

export async function runCompanyWebsiteSpider(token, data){
    return axios({
        method: 'post',
        url: `${BASE_URL}/company_website_spider_crawl_job/run_company_website_spider/`,
        headers : {
            'Authorization': `Token ${token}`
        },
        data: data
    }).then((response) => {
        return response
    }).catch(error => error)
}
